import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { items } from './helpers';

const BreadCrumbs = ({ screen }) => {
  return (
    <div className="h-14 flex absolute items-center top-16 lg:top-12">
      <Link
        className="text-javelin-gray-dark font-bold text-sm inline-block"
        to={items[screen].to}
      >
        {items[screen].name} Report
      </Link>
      <FontAwesomeIcon
        icon="chevron-right"
        className="text-javelin-gray-light mx-2 inline-block opacity-60"
        size="xs"
      />
      <span className="text-javelin-gray-light text-sm">
        {items[screen].name} Details
      </span>
    </div>
  );
};

BreadCrumbs.propTypes = {
  screen: PropTypes.string,
};
BreadCrumbs.defaultProps = {
  screen: 'transaction',
};

export default BreadCrumbs;
